import { render } from "./PlayMessage.vue?vue&type=template&id=7eb0ea76"
import script from "./PlayMessage.vue?vue&type=script&lang=js"
export * from "./PlayMessage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__